import styled from '@emotion/styled';

import Button from 'components/field/Button';
import TextArea from 'components/field/TextArea';
import Card from 'components/global/Card';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { Breakpoints } from 'utils/const.styles';

export const RoundedCard = styled(Card)`
	border-radius: 24px !important;
	width: 50vw;
	padding: 5rem 4rem;

	@media ${Breakpoints.mobile} {
		padding: 2rem;
		border-radius: 0 !important;
	}
`;

export const Divider = styled.div`
	border-top: 1px solid var(--border-color);
	margin: 2.581rem 0;
	flex-grow: 1;
`;

export const LargeOutlinedButton = styled(Button)`
	width: 18rem;
	padding: 2rem 3rem !important;
	display: flex;
	flex-direction: column;
	font-size: 1.5rem;
	color: #183153 !important;
	background-color: transparent !important;
	border-color: var(--blue-10) !important;

	:hover {
		background-color: var(--blue-10) !important;
		border-color: var(--blue) !important;
	}

	&.selected {
		background-color: var(--blue-10) !important;
		border-color: var(--blue) !important;
	}
`;

export const SmallOutlinedButton = styled(Button)`
	padding: 1.72rem 3.871rem !important;
	color: #183153;
	background-color: transparent;
	border-color: var(--blue-10);

	&.selected {
		background-color: var(--alert-info-bg);
		border-color: var(--blue);
	}
`;

export const OrderInformationContentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	width: 100%;
	justify-content: space-between;
	margin-top: 2rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		gap: 2rem;
	}
`;

export const OrderDateWrapper = styled.div`
	text-align: right;
	@media ${Breakpoints.mobile} {
		text-align: left;
	}
`;

export const TimeSlotsWrapper = styled.div`
	.form-item {
		padding: 0;
	}
	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const TimeSlots = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-bottom: 1rem;
	flex-wrap: wrap;
`;

export const LargeIcon = styled(Icon)`
	font-size: 10rem !important;
	margin-bottom: 2rem;
`;

export const AccordionHeader = styled.div`
	&.expanded {
		> div > .expand-icon > svg {
			transform: scale(1, -1);
		}
	}
`;

export const FormWrapper = styled.div`
	> form {
		display: flex;
		flex-direction: column;
		margin-top: 1rem;
	}
`;

export const DeliveryNoteWrapper = styled.div`
	display: grid;
	flex-direction: column;
	gap: 2rem;
	margin: 2rem 0 3rem;

	.form-item {
		padding: 0;
	}
`;

export const FullPageBanner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 10rem;
	height: 80vh;
`;

export const NotResizableTextArea = styled(TextArea)`
	resize: none;
`;

export const HeaderAndActionWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 1rem;
`;

export const MapWrapper = styled.div`
	height: 40dvh;
	margin-bottom: 2rem;
`;

export const CharacterCounter = styled(Typography)`
	text-align: right;
	margin-top: 0.5rem;
`;

export const Banner = styled(Card)`
	border-radius: 24px !important;
	padding: 3rem 20rem;
	display: flex;
	flex-direction: column;
	align-items: center;

	@media ${Breakpoints.mobile} {
		padding: 2rem;
		border-radius: 0 !important;
	}
`;

export const DeliveryOptionsWrapper = styled.div`
	margin: 2rem 0 3.441rem;
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;
